import { cookieService } from '@bfa/nextjs-common/services';
import CookieName, { REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE_TTL, SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE_TTL, } from './cookieName';
var getRefreshmentsPaymentUpdatedCookieName = function (userId) {
    return "".concat(CookieName.REFRESHMENTS_PAYMENT_UPDATED_COOKIE, "_").concat(userId);
};
export var getRefreshmentsPaymentUpdatedCookie = function (userId) {
    return cookieService.getCookie(null, getRefreshmentsPaymentUpdatedCookieName(userId));
};
export var setShowOnboardingTourCookie = function (show) {
    return cookieService.setCookieWithSharedDomain(null, CookieName.SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE, show, {
        maxAge: SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE_TTL,
    });
};
export var setShowOnboardingTourNewbiesCookie = function (show) {
    return cookieService.setCookieWithSharedDomain(null, CookieName.SHOW_REFRESHMENTS_NEWBIES_ONBOARDING_TOUR_COOKIE, show, {
        maxAge: SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE_TTL,
    });
};
export var getShowOnboardingTourUpgradersCookie = function () {
    return cookieService.getCookie(null, CookieName.SHOW_REFRESHMENTS_ONBOARDING_TOUR_COOKIE);
};
export var getShowOnboardingTourNewbiesCookie = function () {
    return cookieService.getCookie(null, CookieName.SHOW_REFRESHMENTS_NEWBIES_ONBOARDING_TOUR_COOKIE);
};
export var getUserDismissedPaymentFailurePageCookie = function () {
    return cookieService.getCookie(null, CookieName.REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE);
};
export var setUserDismissedPaymentFailurePageCookie = function (dismiss) {
    return cookieService.setCookie(null, CookieName.REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE, dismiss, {
        maxAge: REFRESHMENTS_USER_DISMISSED_PAYMENT_FAILURE_PAGE_COOKIE_TTL,
    });
};
export var getCreateSubscriptionSuccessCookie = function () {
    return cookieService.getCookie(null, CookieName.REFRESHMENTS_SUCCESS_SUB);
};
export var removeCreateSubscriptionSuccessCookie = function () {
    return cookieService.getCookie(null, CookieName.REFRESHMENTS_SUCCESS_SUB);
};
export var getCreateSubscriptionErrorCookie = function () {
    return cookieService.getCookie(null, CookieName.REFRESHMENTS_ERROR_SUB);
};
export var removeCreateSubscriptionErrorCookie = function () {
    return cookieService.getCookie(null, CookieName.REFRESHMENTS_ERROR_SUB);
};
